<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {

    }
  },
  watch: {
    $route (to, from) {
          // console.log(to,'to')
          // console.log(from,'from')
      if (to) {
        if (to.path!='/login') {
          this.getRoleRefreshThePermissions()
        }
      }
    },
  },
  created(){
  },
  mounted(){

  },
  methods:{
    getRoleRefreshThePermissions() {
        this.ajax.request({
            url: "/sys/sysRole/roleRefreshThePermissions",
            type: 'get',
            successCallback: (res)=> {
                if (res.code==200) {
                  // console.log(res.data,'是否更新');
                  if (res.data=='1') {
                    this.$router.go(0)
                    this.getUserList()
                  }
                }
            }
        });
    },
    getUserList () {
        let that=this
        this.ajax.request({
            url: "/sys/menu/userMenuList",
            successCallback: function (r) {
              if (r.code==200) {
                function deepFilterMenus(menuList) {
                  if (!Array.isArray(menuList)) return [];

                  return menuList
                    .map(menu => {
                      // 深拷贝当前菜单项，避免修改原数据
                      const filteredMenu = {...menu};
                      // 递归处理子菜单
                      if (filteredMenu.list && Array.isArray(filteredMenu.list)) {
                        filteredMenu.list = deepFilterMenus(filteredMenu.list);
                      }

                      return filteredMenu;
                    })
                    .filter(menu => {
                      // 只保留 status 为 0 的菜单
                      if (menu.status !== 0) {
                        return false;
                      }

                      // 如果有子菜单，检查子菜单是否全部被过滤
                      if (menu.list && menu.list.length === 0) {
                        // 可以在这里决定是否保留没有子菜单的父菜单
                        // 如果希望保留，返回 true；如果希望过滤掉，返回 false
                        return true; // 保留没有子菜单的父菜单
                      }

                      return true;
                    });
                }

                // 应用深度过滤
                r.data = deepFilterMenus(r.data);
                let path = ''
                r.data.map((val,index)=>{
                  val.children=val.list
                  val.path=val.url
                  val.activeIndex='"'+val.menuId+'"'
                  val.code='"'+val.menuId+'"'

                  val.list.map((_val,_index)=>{

                    if (_val.url=='/products') {
                      path= '/index'
                    }
                    if (!path&&r.data.length-1==index&&val.list.length-1==_index) {
                      path=r.data[0].list[0].url
                    }
                    _val.children=_val.list
                    _val.path=_val.url
                    _val.activeIndex='"'+_val.menuId+'"'
                    _val.code='"'+_val.menuId+'"'

                    return _val
                  })
                  return val
                });
                // that.$nextTick(()=>{
                  that.Menu=r.data
                  // that.$forceUpdate();
                // })
                  localStorage.setItem('routeUrl',JSON.stringify(r.data))
                  // if (window.innerWidth < 992) {
                  //   path = '/customer'
                  // }
                  // if (path) {
                  //   that.$router.replace({
                  //     path: path
                  //   })
                  // }
              }
                //  that.MenuFormat()
            }
        });
    },
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  /* min-width: 1200px; */
  overflow-x: auto;
}
/* body {
  -webkit-text-size-adjust: none;
} */
/*解决谷歌不能设置小于12px字体 */
body {
  font: "Microsoft YaHei", "黑体", Helvetica, Arial, Tahoma, sans-serif;
  color: #333;
  margin: 0;
  background: #f5f5f5;
  overflow-x: hidden;
  font-size: 14px;
}
body {
  font-family: "微软雅黑";
  font-weight: 4000;
}
html,
body {
  -webkit-text-size-adjust: none;
  min-height: 100%;
  width: 100%;
  position: relative;
  height: 100%;
  overflow: hidden;
  /* min-width: 1200px; */
  overflow-x: auto;
}
* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  box-sizing: border-box;
  -webkit-touch-callout: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  empty-cells: show;
}
.redColor{
  color: red;
}
.fonsize16{
  font-size: 16px;
}
th,
td {
  border-collapse: collapse;
}
a:link {
  text-decoration: none;
  color: #333;
}
a:visited {
  text-decoration: none;
  color: #333;
}
img {
  border: 0; /*添加以下属性是解决图片在微信浏览器下默认转换效果造成页面模糊*/
  -webkit-transform: scale(1) rotate(0) translate3d(0, 0, 0);
  transform: scale(1) rotate(0) translate3d(0, 0, 0);
  display: inline-block;
  outline: none;
  max-width: 100%;
  max-height: 100%;
}
div,
p,
img,
ul,
ol,
li,
form,
input,
label,
span,
dl,
dt,
dd,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
ol,
ul,
li {
  list-style-type: none;
}
input[type="button"] {
  -webkit-appearance: none;
  outline: none;
}
a,
input {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
input,
select,
textarea {
  background: none;
  outline: none;
  border: none;
}
select::-ms-expand {
  display: none;
}
input::-webkit-input-placeholder {
  font-size: 14px;
  color: #666;
}
select {
  background-color: transparent;
  border-color: transparent;
}
textarea {
  font-family: "微软雅黑";
}
q,
option {
  background: none;
  outline: none;
  border: none;
}
img {
  max-height: 100%;
  max-width: 100%;
  vertical-align: middle;
}
.fleft {
  float: left;
}
.fright {
  float: right;
}
.clearfix {
  display: table;
  content: "";
  clear: both;
}
.clear {
  clear: both;
  height: 0;
  overflow: hidden;
  display: block;
}
.block {
  display: block !important;
}
.none {
  display: none !important;
}
.tabBarView {
  padding-bottom: 60px;
}
.toTop {
  position: fixed;
  bottom: 80px;
  right: 20px;
  width: 40px;
  overflow: hidden;
}
.open {
  overflow: hidden !important;
}
.el-scrollbar .el-scrollbar__wrap {overflow-x: hidden;}
.el-select-dropdown .el-scrollbar .el-scrollbar__wrap,
.el-autocomplete-suggestion .el-scrollbar .el-scrollbar__wrap,
.el-cascader-panel .el-scrollbar .el-scrollbar__wrap {
  overflow: scroll;
}
.ElScrollbar {
  height: 100%;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.small-padding .cell {
  padding-left: 5px;
  padding-right: 5px;
}
.fixed-width .el-button--mini {
  padding: 7px 10px;
  min-width: 60px;
}
@media screen and (max-width: 992px) {
  #app,
  body,
  html {
    min-width: auto;
  }
}
.blue{
  color: blue;
}
</style>



// WEBPACK FOOTER //
// src/App.vue